import { numericStringType } from '@/utils';
import { z } from 'zod';
import { PaymentContractsModel } from './payment-contract';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

const type = z.enum(['payee', 'contractor']);
export type PaymentType = z.infer<typeof type>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const PaymentModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  type,
  name: z.string().min(1),
  isOthers: z.boolean(),
  corporateNumber: numericStringType.length(13).nullish(),
  corporateAddress: z.string().nullish(),
  corporateKind: z.string().length(3).nullish(),
  contracts: PaymentContractsModel,
  totalContractAmount: z.number().nullable(),
  paymentGroupId: z.string().uuid(),
  negativeTotalContractAmountCount: z.number().nullish(),
});

export const PaymentsModel = PaymentModel.array();

const IndirectCostItemModel = z.object({
  label: z.string().nullish(),
  amount: z.number().nullish(),
});

export const IndirectCostModel = z.object({
  label: z.string().nullish(),
  costs: IndirectCostItemModel.array(),
});

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const PaymentFormSchema = PaymentModel.pick({
  type: true,
  corporateAddress: true,
  corporateKind: true,
  paymentGroupId: true,
}).extend({
  isOthers: PaymentModel.shape.isOthers.optional(),
  name: z.string().min(1),
  corporateNumber: z.number().nullish(),
});

const _PaymentMutationParamsSchema = PaymentModel.pick({
  type: true,
  name: true,
  corporateNumber: true,
  corporateAddress: true,
  corporateKind: true,
  paymentGroupId: true,
}).extend({
  projectId: z.string().uuid(),
  isOthers: PaymentModel.shape.isOthers.optional(),
});

const IndirectCostsFormSchema = z.object({
  paymentIndirectCosts: IndirectCostModel.nullable(),
});

const _IndirectCostsMutationSchema = IndirectCostsFormSchema.extend({
  projectId: z.string().uuid(),
});
